<template>
  <div class="container-banner">
    <div class="container main-banner">
      <div class="hero is-small is-fullwidth">
        <div class="hero-body px-3">
          <p class="title">
            {{ bannerData.title || '' }}
          </p>
          <p
            v-if="bannerData.subtitle"
            class="subtitle"
          >
            {{ bannerData.subtitle }}
          </p>
          <button
            v-if="bannerData.showBack"
            type="submit"
            class="button is-small"
            @click="onBack"
          >
            <span class="icon">
              <i
                class="fa fa-arrow-left"
                aria-hidden="true"
              />
            </span>
            <span>
              Volver
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BannerInfoPage',
  props: ['bannerData'],
  data () {
    return {
      title: ''
    }
  },
  methods: {
    onBack () {
      this.bannerData.onBack()
    }
  }
}
</script>
